import { getUserFromCompany } from '@/helpers/api/company'
import { getCompanyClients, getCompanyClient } from '@/helpers/api/users'

const usersStore = {
  namespaced: true,
  state: {
		client: null,
		usersListCount: 0,
		loadingClient: true,
		companyClients: [],
		companyClientsCount: 0,
		companyClientsRecentsId: null,
		loadingCompanyClients: true,
    loadingUserList: true,
    usersList: [],
    newUserModal: false,
    newUserModalEditing: null,
    editUserModal: false,
    usersListForItems: {
      project_id: null,
      users: []
    },
		userSignatureModal: false,
		editPermisosUserModal: false,
		editPermissionsUser: null,
    loadingUserListForItems: false,
    clientModal: false,
    clientModalInfo: null,
		clientCompanyAprovalModal: false
  },
  mutations: {
    setUsersList(state, users) {
      state.usersList = users
    },
    setUsersListCount(state, users_count) {
      state.usersListCount = users_count
    },
    setLoadingUserList(state, status) {
      state.loadingUserList = status
    },
    setCompanyClients(state, users) {
      state.companyClients = users
    },
    setCompanyClientsCount(state, users_count) {
      state.companyClientsCount = users_count
    },
    setCompanyClientsRecentsId(state, users_id) {
      state.companyClientsRecentsId = users_id
    },
    setLoadingCompanyClients(state, status) {
      state.loadingCompanyClients = status
    },
    setClient(state, user) {
      state.client = user
    },
    setClientModal(state, clientModalStatus) {
      state.clientModal = clientModalStatus
    },
    setClientModalInfo(state, clientInfo) {
      state.clientModalInfo = clientInfo
    },
    setLoadingClient(state, status) {
      state.loadingClient = status
    },
    setNewUserModal(state, status) {
      state.newUserModal = status
    },
    setNewUserModalEditing(state, status) {
      state.newUserModalEditing = status
    },
    setEditUserModal(state, status) {
      state.editUserModal = status
    },
    setUsersListForItems(state, users) {
      state.usersListForItems = users
    },
    setLoadingUserListForItems(state, status) {
      state.loadingUserListForItems = status
    },
    setEditPermisosUserModal(state, editPermisosUserModal) {
      state.editPermisosUserModal = editPermisosUserModal
    },
    setEditPermissionsUser(state, editPermissionsUser) {
      state.editPermissionsUser = editPermissionsUser
    },
    setUserSignatureModal(state, status) {
      state.userSignatureModal = status
    },
		setClientCompanyAprovalModal(state, data) {
			state.clientCompanyAprovalModal = data
		}
  },
  actions: {
    async getUserFromCompany({ commit }, {search = null, start = 0, limit = 20, type = 1} = {}) {
			start = isNaN(start) ? 0 : start
      commit('setLoadingUserList', true)
      const data = {
				search,
        start,
        limit,
				type
      }
      const users = await getUserFromCompany(data)
      if (users.code === 200) {
        commit('setUsersList', users.users)
        commit('setUsersListCount', users.users_count)
      }
      commit('setLoadingUserList', false)
    },
    async getCompanyClients({ commit }, {search = null, start = 0, limit = 20, sort_by = null, sort_by_direction = null} = {}) {
			start = isNaN(start) ? 0 : start
      commit('setLoadingCompanyClients', true)
      const data = {
				search,
        start,
        limit,
				sort_by,
				sort_by_direction
      }
      const users = await getCompanyClients(data)
      if (users.code === 200) {
        commit('setCompanyClients', users.users)
        commit('setCompanyClientsCount', users.users_count)
        commit('setCompanyClientsRecentsId', users.recent_user_ids)
      }
      commit('setLoadingCompanyClients', false)
    },
    async getCompanyClient({ commit }, user_id) {
      commit('setLoadingClient', true)
      const user = await getCompanyClient({user_id})
      if (user.code === 200) {
        commit('setClient', user.user)
      }
      commit('setLoadingClient', false)
    }
  }
}

export default usersStore
